module.exports = "/_next/static/images/e04e821a98a6f3dd1521c8d84a2f4dca-nubanker-pm@0.5x.jpg.webp";